import React from 'react';

const CourseTabs = ({ activeTab, setActiveTab }) => {
  const tabs = [
    { id: 'intro', label: '课程简介' },
    { id: 'catalog', label: '学习目录' },
    { id: 'qa', label: '提问回复' },
    { id: 'review', label: '学员评价' }
  ];
  
  return (
    <div className="course-tabs">
      {tabs.map(tab => (
        <button
          key={tab.id}
          className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
          onClick={() => setActiveTab(tab.id)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default CourseTabs; 